import { Input } from "@/components/ui/input";
import { Field, PickSelect, StepHeader } from "@/components/apply/Field";
import { COUNTRIES, TIMEZONES } from "@/data/options";

const DIALS = [...new Set(COUNTRIES.map((c) => c.dial))];
const dialOptions = DIALS.map((d) => ({
  value: d,
  label: `${d} ${COUNTRIES.filter((c) => c.dial === d).map((c) => c.code).join("/")}`,
}));

export const StepContact = ({ form, update }) => {
  const c = form.contact;
  const set = (k) => (v) => update("contact", k, v);
  const onCountry = (name) => {
    set("country")(name);
    const match = COUNTRIES.find((x) => x.name === name);
    if (match && match.dial !== "+") set("phone_code")(match.dial);
  };
  return (
    <div data-testid="step-contact">
      <StepHeader title="Let's start with you" text="How we'll reach you about your application." />
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Full name">
          <Input className="h-12 rounded-xl" value={c.full_name} onChange={(e) => set("full_name")(e.target.value)} data-testid="apply-full-name-input" />
        </Field>
        <Field label="Email">
          <Input type="email" className="h-12 rounded-xl" value={c.email} onChange={(e) => set("email")(e.target.value)} data-testid="apply-email-input" />
        </Field>
        <Field label="Country">
          <PickSelect value={c.country} onChange={onCountry} options={COUNTRIES.map((x) => x.name)} placeholder="Choose country" testId="apply-country-select" />
        </Field>
        <Field label="City">
          <Input className="h-12 rounded-xl" value={c.city} onChange={(e) => set("city")(e.target.value)} data-testid="apply-city-input" />
        </Field>
        <Field label="Phone">
          <div className="flex gap-2">
            <div className="w-36 shrink-0">
              <PickSelect value={c.phone_code} onChange={set("phone_code")} options={dialOptions} testId="apply-phone-code-select" />
            </div>
            <Input type="tel" className="h-12 rounded-xl" value={c.phone} onChange={(e) => set("phone")(e.target.value)} placeholder="Phone number" data-testid="apply-phone-input" />
          </div>
        </Field>
        <Field label="Preferred time zone" hint="Interview times will be shown in this time zone.">
          <PickSelect value={c.timezone} onChange={set("timezone")} options={TIMEZONES} testId="apply-timezone-select" />
        </Field>
      </div>
    </div>
  );
};
